import { useHistory } from "react-router-dom";
import { i18n } from "src/i18n";

interface UpgradeRequiredProps {
  setIsUpgradeModalVisible: (visible: boolean) => void;
  isFrequency?: boolean;
}

const UpgradeRequired = (props: UpgradeRequiredProps): JSX.Element => {
  const history = useHistory();
  const { setIsUpgradeModalVisible, isFrequency } = props;
  const handleCancel = () => {
    setIsUpgradeModalVisible(false);
  };
  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 transition-opacity bg-[#003A4B] bg-opacity-60 modal-width backdrop-blur-[5px]"></div>
      <div className="fixed left-1/2 top-1/2 z-50 flex w-[390px] max-w-[90%] -translate-y-1/2 -translate-x-1/2 transform flex-col justify-center rounded-[20px] bg-gradient-to-b from-[#FFFFFF] to-[#CEDFD7] p-[23px] sm:left-[calc(50%+125px)]">        <div className="flex items-center justify-between">
          <h3
            className="text-[20px] font-[600] text-[#003A4B] font-syneBold"
            id="modal-title"
          >
            Upgrade Required
          </h3>
          <img
            onClick={handleCancel}
            className="w-[19px] object-cover cursor-pointer"
            src="/images/icon-close.svg"
          />
        </div>
        <div className="mt-[20px] flex flex-col items-center justify-center text-center">
          <img
            src="/images/icon-lock-v2_1.svg"
            alt=""
            className="w-[64px] object-cover"
          />
          <h3 className="mt-[10px] text-[18px] font-[400] text-[#003A4B]">
            Full Access Membership
          </h3>
          <p className="mt-[10px] text-[16px] font-[400] text-[#003A4B]">
            Upgrade your membership to unlock all features and enhance your
            experience.
          </p>
        </div>
        <div className="mb-[18px] mt-[30px] flex flex-col px-[24.5px]">
          <button
            type="button"
            onClick={() => history.push("/settings/manage-subscription")}
            className="h-[48px] w-full transform rounded-full bg-[#035C67] text-[16px] font-[400] tracking-wide text-white shadow-[0px_1.5px_4px_0px_#00000066] transition-colors duration-200 hover:bg-darkGreen focus:bg-darkGreen focus:outline-none disabled:cursor-default disabled:opacity-50"
          >
            Upgrade Now
          </button>
          <a
            href="#"
            onClick={handleCancel}
            className="mt-[15px] flex h-[48px] w-full transform items-center justify-center rounded-full bg-[#FFF] text-[16px] font-[400] tracking-wide text-[#035C67] shadow-[0px_1.5px_4px_0px_#00000066] transition-colors duration-200 hover:bg-darkGreen focus:bg-darkGreen focus:outline-none disabled:cursor-default disabled:opacity-50"
          >
            Maybe Later
          </a>
        </div>
      </div>
    </div>
  );
};

export default UpgradeRequired;
